import { Button, Card, CardContent, CardHeader, FormControlLabel, Grid, Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import 'react-virtualized/styles.css';
import { getAllQuestions, removeAnswers, saveAnswers } from '../../services';
import FORM_HEADERS, { VALUATION_FORM_HEADERS, VALUATION_FORM_HEADERS_WITH_BUTTON } from './../../enums/formHeaders';
import AllPhotos from './AllPhotos';
import FormDefinition from './FormDefinition';
import FormHeaderImages from './FormHeaderImages';
import { FormHeader } from './FormHeaders';
import HazardHubData from './HazardHubData';
import VexcelPropertyData from './VexcelPropertyData';
import ImageCard from './ImageCard';
import { OrderCancelReport } from './OrderCancelReport';
import OrderRecommendations from './OrderRecommendations';
import { OrderReviewContext } from './OrderReviewContext';
import Sketch from './Sketch';
import ValuationHistory from './ValuationHistory';
import { AppContext } from '../../AppContext';

import { OrderDetailBetterViewiFrameTab, OrderDetailVexceliFrameTab } from '../Orders/orderDetailTabs';
import { cloneDeep } from 'lodash';
import RemoteInvisionData from './RemoteInvisionData';
import HoverSketch from './HoverSketch';
const IS_PROD = process.env.NODE_ENV === 'production';

const propTypes = {
  classes: PropTypes.object.isRequired,
  isCustomerCloseOutForm: PropTypes.bool,
  isCancelled: PropTypes.bool,
};

const Content = ({
  classes,
  isCancelled,
  isCustomerCloseOutForm = false,
  order,
  setOrder,
  setPdfPreviewLink,
  setIsCompleteDialogOpen,
  sideViewForm,
  setSideViewForm,
  setIsAllPhotosTab,
  hideAllPhotos,
  taggedPhotos,
  setTaggedPhotos,
}) => {
  const { state, dispatch } = useContext(OrderReviewContext);
  const { state: appState, dispatch: appDispatch } = useContext(AppContext);

  const activeFormHeader = state.formHeaders[state.activeFormHeaderIndex];
  const activeFormHeaderId = activeFormHeader.formHeaderId;
  const activeFormHeaderDefinitions = activeFormHeader.formDefinitions;

  // cancellation QA users (Qa.CanProcessCancel) can still edit specific forms (FormHeader.CanEditOnCancel)
  // prior to finalizing a canceled order, so the normal cancelled read-only overlay shouldn't apply to those
  const isEditableWhileCancelled = isCancelled && appState.canProcessCancel && !!activeFormHeader.canEditOnCancel;

  const formHasImages = activeFormHeaderDefinitions?.flatMap(fd => fd.answers).flatMap(a => a.images).length > 0;
  const formHasValuation = VALUATION_FORM_HEADERS.includes(activeFormHeaderId);
  const formHasValuationButton = VALUATION_FORM_HEADERS_WITH_BUTTON.includes(activeFormHeaderId);

  const formHasSketch = activeFormHeaderId === FORM_HEADERS.SKETCH;

  const activeFormHeaderFormDefinitionList = activeFormHeader.formDefinitions;

  const [showHiddenImages, setShowHiddenImages] = useState(false);
  
  
  const showSnackbar = (message, variant) => {
    appDispatch({
      type: 'SET_SNACKBAR',
      snackbar: { isOpen: true, message: message, variant: variant },
    });
  };

  const saveAnswersAsync = async (answers, image) => {
    dispatch({
      type: 'IS_AUTO_SAVING',
      value: true,
    });
    const maxSaveAttempts = 3;
    let saveAttempts = 0;

    const attemptSave = async () => {
      try {
        await saveAnswers(answers, image);
        saveAttempts = 0;
        dispatch({
          type: 'IS_EDITING',
          value: false,
        });
        dispatch({
          type: 'IS_AUTO_SAVING',
          value: false,
        });
      } catch (error) {
        console.log(error);
        saveAttempts = saveAttempts + 1;
        if (saveAttempts > maxSaveAttempts) {
          showSnackbar('An error occurred while saving. Please try again.', 'error');
          dispatch({
            type: 'IS_EDITING',
            value: false,
          });
          dispatch({
            type: 'IS_AUTO_SAVING',
            value: false,
          });
        } else {
          console.log(`${saveAttempts}: An error occurred while saving. Retrying...`);
          setTimeout(function() {
            attemptSave(answers);
          }, 750);
        }
      }
    };

    attemptSave(answers);
  };

  const removeAnswersAsync = async formDefinitions => {
    dispatch({
      type: 'IS_AUTO_SAVING',
      value: true,
    });

    const maxSaveAttempts = 3;
    let saveAttempts = 0;

    const attemptRemove = async formDefinitions => {
      try {
        await removeAnswers(formDefinitions);
        saveAttempts = 0;
        dispatch({
          type: 'IS_AUTO_SAVING',
          value: false,
        });
      } catch (error) {
        console.log(error);
        saveAttempts = saveAttempts + 1;
        if (saveAttempts > maxSaveAttempts) {
          showSnackbar('An error occurred while saving. Please try again.', 'error');
          dispatch({
            type: 'IS_AUTO_SAVING',
            value: false,
          });
        } else {
          console.log(`${saveAttempts}: An error occurred while saving. Retrying...`);
          setTimeout(function() {
            attemptRemove(formDefinitions);
          }, 1000);
        }
      }
    };
    attemptRemove(formDefinitions);
  };

  const handleToggleHiddenImageVisibility = () => {
    setShowHiddenImages(!showHiddenImages);
  };

  const handleShowAllAnswersClick = () => {
    dispatch({
      type: 'SHOW_ALL_ANSWERS',
      value: !state.showAllAnswers,
    });
  };

  // const willTriggerTrailReachOrderFormHeader = (at, endingFormDefinitionId, questionList) => {
  //   const { triggerToFormDefinitionId } = at;

  //   const triggerToQuestion = questionList.find(q => q.formDefinitionId == triggerToFormDefinitionId);

  //   if (!triggerToQuestion) {
  //     return false;
  //   }

  //   if (triggerToQuestion.formDefinitionId == endingFormDefinitionId) {
  //     return true;
  //   }

  //   if (triggerToQuestion.answerTriggers.length > 0) {
  //     return triggerToQuestion.answerTriggers.every(nestedAnswerTrigger =>
  //       willTriggerTrailReachOrderFormHeader(nestedAnswerTrigger, endingFormDefinitionId, questionList),
  //     );
  //   }

  //   return false;
  // };

  // const computeRenderedQuestions = fullQuestionList => {
  //   let renderedQuestions = [];

  //   fullQuestionList.forEach(q => {
  //     const DEBUG =
  //       !IS_PROD &&
  //       [
  //         //
  //         // 14138, // take photo: additional photo
  //         // 14204, // roof shape
  //         //
  //         // 14160, // dog on premise
  //         // 14161, // dog breed - aggressive
  //         //
  //         // 10239, // roof structure
  //         // 12337, // roof structure %: bar joists with metal deck
  //         // 12348, // Roof Structure %: Wood Trusses & Sheathing
  //         //
  //         // 14444, // age of roof
  //       ].includes(q.formDefinitionId);

  //     if (!q.triggeredByFormDefinitionIds?.length) {
  //       DEBUG && console.log(q.formDefinitionId, 'no triggered by form defs');
  //       renderedQuestions.push(q);
  //       return;
  //     }

  //     const triggeredByTakePhotoQuestionsOnlyOrTriggerDoesNotExist = q.triggeredByFormDefinitionIds.every(
  //       triggerByFormDefId => {
  //         const originalQuestion = fullQuestionList.find(question => question.formDefinitionId === triggerByFormDefId);

  //         const originalQuestionExists = !!originalQuestion;
  //         const isTakePhotoQuestion =
  //           originalQuestionExists && originalQuestion.questionValue.toLowerCase().includes('take photo:');

  //         return !originalQuestionExists || isTakePhotoQuestion;
  //       },
  //     );

  //     DEBUG &&
  //       console.log(q.formDefinitionId, {
  //         triggeredByTakePhotoQuestionsOnlyOrTriggerDoesNotExist,
  //       });

  //     if (triggeredByTakePhotoQuestionsOnlyOrTriggerDoesNotExist) {
  //       DEBUG && console.log(q.formDefinitionId, 'triggeredByTakePhotoQuestionsOnlyOrTriggerDoesNotExist');
  //       renderedQuestions.push(q);
  //       return;
  //     }

  //     const visibleTriggeredByFormDefinitions = renderedQuestions.filter(rq =>
  //       q.triggeredByFormDefinitionIds.includes(rq.formDefinitionId),
  //     );

  //     DEBUG &&
  //       console.log(q.formDefinitionId, {
  //         visibleTriggeredByFormDefinitions,
  //         // allTriggeredByFormDefinitions,
  //         renderedQuestions,
  //         q,
  //       });

  //     let shouldShowQuestion = false;

  //     shouldShowQuestion = visibleTriggeredByFormDefinitions.some(tq => {
  //       const triggerHasAnswers = tq.answers.length > 0;

  //       if (!triggerHasAnswers) {
  //         const defaultTrigger = tq.answerTriggers.find(at => at.answerValueId == 0);
  //         const defaultTriggerIsMatch = defaultTrigger?.triggerToFormDefinitionId === q.formDefinitionId;

  //         DEBUG &&
  //           console.log({
  //             triggerHasAnswers,
  //             answers: tq.answerTriggers,
  //             defaultTrigger,
  //             defaultTriggerIsMatch,
  //           });

  //         if (defaultTriggerIsMatch) {
  //           DEBUG && console.log(q.formDefinitionId, 'defaultTriggerIsMatch');
  //           return true;
  //         }

  //         const allTriggersHaveSameTriggerTo =
  //           new Set(tq.answerTriggers.map(at => at.triggerToFormDefinitionId)).size == 1;

  //         DEBUG &&
  //           console.log({
  //             allTriggersHaveSameTriggerTo,
  //           });

  //         if (allTriggersHaveSameTriggerTo) {
  //           DEBUG && console.log(q.formDefinitionId, 'allTriggersHaveSameTriggerTo');
  //           return true;
  //         }

  //         return false;

  //         // const allTriggersLeadToThisQuestionEventually =
  //         //   !!tq.answerTriggers?.length &&
  //         //   tq.answerTriggers.every(at =>
  //         //     willTriggerTrailReachOrderFormHeader(at, q.formDefinitionId, fullQuestionList),
  //         //   );

  //         // DEBUG &&
  //         //   console.log(q.formDefinitionId, {
  //         //     defaultTrigger,
  //         //     allTriggersHaveSameTriggerTo,
  //         //     allTriggersLeadToThisQuestionEventually,
  //         //   });

  //         // return allTriggersLeadToThisQuestionEventually;
  //       }

  //       // const relatedAnswerTriggers = tq.answerTriggers.filter(at => at.triggerToFormDefinitionId === q.formDefitionId);

  //       /**
  //        * run a filter instead of a find for the multi-select answers (in which case only the first answer was only being shown)
  //        */
  //       const isMatch = tq.answerTriggers
  //         .filter(at => {
  //           const atMatches = tq.answers.some(a => a.valueId == at.answerValueId || (!a.valueId && !at.answerValueId));
  //           // DEBUG &&
  //           //   console.log(q.formDefinitionId, {
  //           //     // valueId: a.valueId,
  //           //     answerValueId: at.answerValueId,
  //           //     atMatches,
  //           //     answers: tq.answers,
  //           //   });

  //           return atMatches;
  //         })
  //         .some(at => at?.triggerToFormDefinitionId === q.formDefinitionId);

  //       DEBUG &&
  //         console.log(q.formDefinitionId, {
  //           // relatedAnswerTriggers,
  //           // relatedAnswerTriggersFiltered: tq.answerTriggers.filter(at => at.triggerToFormDefinitionId === q.formDefinitionId),
  //           isMatch,
  //           formDefId: q.formDefinitionId,
  //         });

  //       if (isMatch) {
  //         DEBUG && console.log(q.formDefinitionId, 'isMatch');
  //       }

  //       return isMatch;
  //     });

  //     const existingTriggeredByFormDefinitionIds = q.triggeredByFormDefinitionIds.filter(tbfdId =>
  //       fullQuestionList.some(question => question.formDefinitionId === tbfdId),
  //     );

  //     DEBUG &&
  //       console.log(q.formDefinitionId, {
  //         existingTriggeredByFormDefinitionIds,
  //       });

  //     if (!shouldShowQuestion && existingTriggeredByFormDefinitionIds.length > 1) {
  //       const calculateFormDefinitionIdHistory = (formDefinitionId, currentHistory = []) => {
  //         const question = fullQuestionList.find(q => q.formDefinitionId === formDefinitionId);

  //         if (!question) return currentHistory;

  //         if (!question.triggeredByFormDefinitionIds.length) {
  //           return currentHistory.concat(formDefinitionId);
  //         }

  //         DEBUG &&
  //           console.log(q.formDefinitionId, {
  //             currentHistory,
  //             formDefinitionId,
  //           });

  //         const nestedExistingTriggeredByFormDefinitionIds = question.triggeredByFormDefinitionIds.filter(tbfdId =>
  //           fullQuestionList.some(question => question.formDefinitionId === tbfdId),
  //         );

  //         return nestedExistingTriggeredByFormDefinitionIds.map(tbfdId => {
  //           const newRoutes = calculateFormDefinitionIdHistory(tbfdId);
  //           return newRoutes.flatMap(route => currentHistory.concat(formDefinitionId).concat(route));
  //         });
  //       };

  //       const formDefIdHistory = calculateFormDefinitionIdHistory(q.formDefinitionId);

  //       DEBUG &&
  //         console.log(q.formDefinitionId, {
  //           formDefIdHistory,
  //           q,
  //         });

  //       const formDefIdHistoryCommonAncestors = !formDefIdHistory.length
  //         ? []
  //         : formDefIdHistory.reduce((accArr, checkArray) => accArr.filter(aaValue => checkArray.includes(aaValue)));

  //       const ancestorIsVisible =
  //         !!formDefIdHistoryCommonAncestors.length &&
  //         formDefIdHistoryCommonAncestors.some(formDefId =>
  //           renderedQuestions.filter(rq => rq.formDefinitionId === formDefId),
  //         );

  //       DEBUG &&
  //         console.log(q.formDefinitionId, {
  //           formDefIdHistoryCommonAncestors,
  //         });

  //       if (ancestorIsVisible) {
  //         DEBUG && console.log(q.formDefinitionId, 'ancestorIsVisible');
  //       }

  //       shouldShowQuestion = ancestorIsVisible;
  //     }

  //     if (shouldShowQuestion) {
  //       renderedQuestions.push(q);
  //     }
  //   });

  //   return renderedQuestions;
  // };

  // useEffect(() => {
  //   if (!activeFormHeaderFormDefinitionList) return;

  //   let questionsClone = cloneDeep(activeFormHeaderFormDefinitionList);
  //   let renderedList = computeRenderedQuestions(questionsClone);

  //   if (!IS_PROD) {
  //     renderedList = renderedList.map(q => {
  //       if (q.questionValue === 'Age of roof') {
  //         // q.answerType = 'Single Select';
  //       }

  //       return q;
  //     });

  //     console.log({ questionsClone, renderedList });
  //     window.questions = questionsClone;
  //     window.rendered = renderedList;
  //   }

  //   setActiveFormDefinitions(renderedList);
  // }, [state.formHeaders, state.activeFormHeaderIndex]);

  useEffect(() => {
    if (activeFormHeaderId !== 'all-photos-tab') {
      setIsAllPhotosTab(false);
    }
  }, [state.activeFormHeaderIndex]);

  /*********************************
   * START: Short circuiting component
   *********************************/
  if (formHasSketch) {
    return <Sketch />;
  }
  if (activeFormHeaderId === 'all-photos-tab') {
    setIsAllPhotosTab(true);
    return (
      <AllPhotos
        saveAnswersAsync={saveAnswersAsync}
        removeAnswersAsync={removeAnswersAsync}
        hideAllPhotos={hideAllPhotos}
        taggedPhotos={taggedPhotos}
      />
    );
  }
  if (activeFormHeaderId === 'hazard-hub-tab') {
    return <HazardHubData />;
  }
  if (activeFormHeaderId === 'vexcel-property-tab') {
    return <VexcelPropertyData />;
  }
  if (state.formHeaders[state.activeFormHeaderIndex].formHeaderId === 'remote-invision-tab') {
    return <RemoteInvisionData />;
  }
  if (state.formHeaders[state.activeFormHeaderIndex].formHeaderId === 'order-recommendations-tab') {
    return <OrderRecommendations />;
  }
  if (activeFormHeaderId === 'valuation-history-tab') {
    return <ValuationHistory />;
  }
  if (state.formHeaders[state.activeFormHeaderIndex].name === 'Hover Sketch') {
    return <HoverSketch />;
  }
  if (state.formHeaders[state.activeFormHeaderIndex].formHeaderId === 1117) {
    return <OrderDetailBetterViewiFrameTab orderLineId={state.orderLineId} />;
  }
  if (activeFormHeaderId === 1120) {
    return <OrderDetailVexceliFrameTab orderLineId={state.orderLineId} />;
  }
  if (activeFormHeaderId === 'cancelled-tab') {
    return (
      <OrderCancelReport
        order={order}
        setPdfPreviewLink={setPdfPreviewLink}
        setIsCompleteDialogOpen={setIsCompleteDialogOpen}
        setOrder={setOrder}
      />
    );
  }
  /*********************************
   * END: Short circuiting component
   *********************************/

  return (
    <React.Fragment>
      <FormHeaderImages showHiddenImages={showHiddenImages} />
      <Grid
        container
        style={{
          paddingRight: formHasImages ? '12px' : '0',
          overflowY: 'auto',
          flex: 1,
        }}
      >
        {sideViewForm && formHasImages ? (
          <Grid
            id="images-container"
            item
            xs={12}
            md={8}
            style={{
              overflowY: 'auto',
              overflowX: 'hidden',
              height: '100%',
              padding: '1px 1px 0px 1px',
            }}
          >
            <Grid container spacing={0}>
              {state.formHeaders
                .filter(fh => fh.images)
                .flatMap(fh => fh.images)
                .filter(fhi =>
                  activeFormHeaderDefinitions
                    // .filter(fd => fd.questionCategoryId === 1)
                    .flatMap(fd => fd.answers)
                    .flatMap(a => a.images)
                    .some(i => (showHiddenImages || !i.hideImage) && i.formQaImageId == fhi.formQaImageId),
                )
                .sort(i => i.formQaImageId)
                .map((image, index) => (
                  <ImageCard
                    key={image.formQaImageId}
                    image={image}
                    saveAnswers={saveAnswersAsync}
                    removeAnswers={removeAnswersAsync}
                    formHeader={activeFormHeader}
                  />
                ))}
            </Grid>
            {state.isRCT && <div dangerouslySetInnerHTML={{ __html: state.content }} />}
          </Grid>
        ) : (
          <Grid
            id="images-container"
            item
            xs={12}
            md={12}
            style={{
              padding: '1px 1px 0px 1px',
              display: 'flex',
            }}
          >
            <Grid container spacing={0} className={'overflow-auto'}>
              {state.formHeaders
                .filter(fh => fh.images)
                .flatMap(fh => fh.images)
                .filter(fhi =>
                  activeFormHeaderDefinitions
                    .filter(fd => fd.questionCategoryId === 1)
                    .flatMap(fd => fd.answers)
                    .flatMap(a => a.images)
                    .some(i => (showHiddenImages || !i.hideImage) && i.formQaImageId == fhi.formQaImageId),
                )
                .sort(i => i.formQaImageId)
                .map((image, index) => (
                  <ImageCard
                    key={image.formQaImageId}
                    image={image}
                    saveAnswers={saveAnswersAsync}
                    removeAnswers={removeAnswersAsync}
                    formHeader={activeFormHeader}
                  />
                ))}
            </Grid>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={formHasImages && sideViewForm ? 4 : formHasValuationButton ? 9 : 12}
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '100%',
            padding: formHasImages && !formHasValuation ? '1px 1px 12px 12px' : 1,
            //pointerEvents: isCancelled ? 'none' : 'auto',
            opacity: isCancelled && !isCustomerCloseOutForm && !isEditableWhileCancelled ? 0.5 : 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid item xs={12} className="flex-1 flex-column" style={{ pointerEvents: isCancelled && !isCustomerCloseOutForm && !isEditableWhileCancelled ? 'none' : 'auto' }}>
            <Card className="border-left-green flex-1 flex-column">
              <CardHeader
                className={classes.cardHeader}
                titleTypographyProps={{
                  className: classes.cardHeaderTitle,
                }}
                title="Property Characteristics"
              />
              <CardContent
                className={classNames(classes.cardContent, 'flex-1 flex-column  overflow-y-auto')}
                style={{
                  overflowX: 'hidden',
                }}
              >
                <div className={classes.buttonWrapper}>
                  <Button
                    aria-label="Toggle Image Visibility"
                    className={classes.button}
                    onClick={handleToggleHiddenImageVisibility}
                  >
                    Hidden Photos
                    {showHiddenImages ? (
                      <VisibilityIcon className={classes.rightIcon} />
                    ) : (
                      <VisibilityOffIcon className={classes.rightIcon} />
                    )}
                  </Button>
                  <Button aria-label="Show/Hide Answers" className={classes.button} onClick={handleShowAllAnswersClick}>
                    {state.showAllAnswers ? 'Hide Non-Issues' : 'Show All'}
                    {state.showAllAnswers ? (
                      <ToggleOffOutlinedIcon className={classes.rightIcon} />
                    ) : (
                      <ToggleOnIcon className={classes.rightIcon} />
                    )}
                  </Button>
                </div>
                <div className={classNames(classes.formDefinitionWrapper, 'flex-1 flex-column ')}>
                  <FormHeader
                    key={activeFormHeaderId}
                    formDefinitions={activeFormHeaderFormDefinitionList}
                    saveAnswersAsync={saveAnswersAsync}
                    removeAnswersAsync={removeAnswersAsync}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {formHasValuation && formHasValuationButton && (
          <Grid
            item
            xs={12}
            md={3}
            style={{
              overflowY: 'auto',
              overflowX: 'hidden',
              height: '100%',
              padding: '1px 1px 12px 12px',
              flex: 1,
            }}
          >
            <Card className="border-left-green">
              <CardHeader
                className={classes.cardHeader}
                titleTypographyProps={{
                  className: classes.cardHeaderTitle,
                }}
                title="Calculate Valuation"
              />
              <CardContent className={classNames(classes.cardContent)}>
                <div className={classes.valuationSidebarWrapper}>
                  <Grid container>
                    {activeFormHeaderFormDefinitionList
                      .filter(fd => fd.qaFieldContext === 'Calculate Valuation')
                      .map((fd, i) => (
                        <Grid item xs={12} key={`${fd.formDefinitionId}-${fd.answers[0]?.text}`}>
                          <FormDefinition
                            formDefinition={fd}
                            removeAnswers={removeAnswersAsync}
                            saveAnswers={saveAnswersAsync}
                          />
                        </Grid>
                      ))}
                  </Grid>
                </div>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

const styles = theme => ({
  cardContent: {
    padding: '0',
  },
  cardHeader: {
    padding: '12px',
    backgroundColor: '#fafafa',
  },
  cardHeaderTitle: {
    fontSize: '1rem',
    fontWeight: '700',
    textAlign: 'left',
    color: 'var(--jmi-blue)',
  },
  buttonWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  button: {
    width: '100%',
    '&:hover': {
      cursor: 'pointer',
    },
    border: '1px solid #ebebeb',
    fontWeight: '600',
  },
  valuationSidebarWrapper: {
    padding: '24px',
  },
  formDefinitionWrapper: {
    padding: '0',
  },
  rightIcon: {
    marginLeft: '8px',
  },
});

Content.propTypes = propTypes;
export default withStyles(styles)(Content);
